export default function header() {
  return {
    _id: false,
    type: 'droplet.header',
    text: "I'm a header",
    hSize: 'h2',
    mediaQueries: [
      {
        selector: '.drz-header',
        properties: [
          {
            property: 'font-size',
            desktop: '35pt',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/header/droplet.schema.js